/* eslint-disable react/jsx-props-no-spreading */

import noop from 'lodash/noop'

import SingleObjectSelectorConverter from 'app/shared-components/SingleObjectSelectorConverter'

import Select from '../SelectContainer'

type Props = {
    title?: string,
    name?: string,
    onChange: (value: any, ...params: any[]) => void,
    value?: { id: string | number },
    data?: any[],
    allowedValues?: Record<string, string>,
    hasError?: string,
    required?: boolean,
    timeFormat?: boolean,
    disableUnderline?: boolean,
    disableHelperText?: boolean,
    disableSorting?: boolean,
    className?: {
        formControl?: string,
        overrideSelect?: string,
        select?: string,
    },
    showOutOfRangeOption?: boolean,
    labelOutOfRangeValue?: string,
    noNone?: boolean,
}

const defaultProps: Partial<Props> = {
    title: '',
    name: '',
    data: [],
    allowedValues: {},
    onChange: noop,
    value: undefined,
    hasError: '',
    required: false,
    timeFormat: false,
    disableUnderline: false,
    disableSorting: false,
    disableHelperText: false,
    className: {},
    showOutOfRangeOption: false,
    labelOutOfRangeValue: undefined,
    noNone: undefined,
}

const ObjectSelect = (props: Readonly<Props>) => {
    return (
        <SingleObjectSelectorConverter
            {...props}
            selector={Select}
        />
    )
}

ObjectSelect.defaultProps = defaultProps

export default ObjectSelect
